module.exports = __webpack_public_path__ + "static/img/10.92381a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/10.png
// module id = ru52
// module chunks = 1